export class DrupalBaseModel {

  public uuid: string;
  public nid: number;
  public cmsPath: string;

  // any other drupal specific fields go here

  constructor(values?: Partial<DrupalBaseModel>) {
    Object.assign(this, values);
  }
}
